export enum TreasuryTransferTypeEnum {
  'settlement' = 'settlement',
  'bank' = 'bank',
  'fireOpen' = 'fireOpen'
}
